module.exports = __webpack_public_path__ + "d04a1ebe1eeac34118064fcaab0aaa58.svg";